<div class="modal-header bg-dark text-white">
    <h3 class="modal-title" id="modal-basic-title">{{ header }}</h3>
    <div class="ms-auto" data-bs-theme="dark">
      <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
    </div>
</div>
<div class="modal-body">
    <div class="alert alert-info d-flex align-items-start" *ngIf="formType == 'add'">
        <i class="fas fa-info-circle mt-1 me-2"></i>
        <span><strong>Avoiding duplicates:</strong> when the company name and the contact's email domain both
            match a supplier already on file, we'll add this contact to that company instead of creating a new one.</span>
    </div>
    <form [formGroup]="form" novalidate>
        <div class="row mb-3">
            <div class="form-group col-12 col-md-4">
                <label>{{ legal.name }}
                    <i class="fas fa-info-circle text-muted ms-1" placement="top" data-testid="supplier-company-tip"
                       [ngbTooltip]="legal.nameTipOther" [attr.aria-label]="legal.nameTipOther"></i>
                </label>
                <input class="form-control" formControlName="name"
                       [ngClass]="getFormGroupErrorClasses(form.controls.name)"
                       [placeholder]="legal.name">
                <div class="invalid-feedback" *ngIf="showErrorBlock(form.controls.name)">
                    <p *ngIf="form.controls.name.errors.required">{{ legal.nameRequired }}</p>
                </div>
                <small class="form-text text-muted"></small>
            </div>

            <div class="form-group col-12 col-md-4">
                <label>Supplier Alias (Internal Name)
                    <i class="fas fa-info-circle text-muted ms-1" placement="top"
                       ngbTooltip="Optional: your company's internal name for this supplier"></i>
                </label>
                <input class="form-control" formControlName="supplier_alias"
                       placeholder="e.g., Preferred Supplier">
            </div>
        </div>
        <div class="row mb-3">
            <div formGroupName="contact" class="form-group col-12 col-md-4" [ngClass]="getFormGroupErrorClasses(contact.controls.first_name)">
                <label>First Name</label>
                <input class="form-control" formControlName="first_name"
                       [ngClass]="getFormGroupErrorClasses(contact.controls.first_name)"
                       placeholder="First Name">
                <div class="invalid-feedback" *ngIf="showErrorBlock(contact.controls.first_name)">
                    <p *ngIf="contact.controls.first_name.errors.required">First Name field is required</p>
                </div>
                <small class="form-text text-muted"></small>
            </div>
            <div formGroupName="contact" class="form-group col-12 col-md-4" [ngClass]="getFormGroupErrorClasses(contact.controls.last_name)">
                <label>Last Name</label>
                <input class="form-control" formControlName="last_name"
                       [ngClass]="getFormGroupErrorClasses(contact.controls.last_name)"
                       placeholder="Last Name">
                <div class="invalid-feedback" *ngIf="showErrorBlock(contact.controls.last_name)">
                    <p *ngIf="contact.controls.last_name.errors.required">Last Name field is required</p>
                </div>
                <small class="form-text text-muted"></small>
            </div>
        </div>
        <div formGroupName="contact" class="row">
            <div class="form-group col-12 col-md-4" [ngClass]="getFormGroupErrorClasses(contact.controls.email)">
                <label>Email</label>
                <input toLowercase type="email" class="form-control" formControlName="email"
                       [ngClass]="getFormGroupErrorClasses(contact.controls.email)"
                       placeholder="Email">
                <div class="invalid-feedback" *ngIf="showErrorBlock(contact.controls.email)">
                    <p *ngIf="contact.controls.email.errors.required">Email field is required</p>
                </div>
                <small class="form-text text-muted"></small>
            </div>
            <div class="form-group col-12 col-md-4" [ngClass]="getFormGroupErrorClasses(contact.controls.phone)">
                <label>Phone</label>
                <input [mask]="phoneMask" class="form-control" formControlName="phone"
                       [ngClass]="getFormGroupErrorClasses(contact.controls.phone)"
                       placeholder="Phone">
                <div class="invalid-feedback" *ngIf="showErrorBlock(contact.controls.phone)">
                    <p *ngIf="contact.controls.phone.errors.required">Phone field is required</p>
                </div>
                <small class="form-text text-muted"></small>
            </div>
            <div class="form-group col-12 col-md-4" [ngClass]="getFormGroupErrorClasses(contact.controls.phone)">
                <label>Tags</label>
                <ng-template [ngIf]="formType != 'add'">
                    <ng-select
                      [items]="tags"
                      [addTag]="addTagPromise"
                      [loading]="loading"
                      multiple="true"
                      bindLabel="name"
                      (ngModelChange)="tagChange($event)"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="selectedTags">
                    <ng-template ng-tag-tmp let-search="searchTerm"><b>create new</b>: {{ search }} </ng-template>
                </ng-select>
                </ng-template>
                <ng-template [ngIf]="this.formType == 'add'">
                    <ng-select
                      [items]="tags"
                      multiple="true"
                      bindLabel="name"
                      (ngModelChange)="tagChange($event)"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="selectedTags">
                    </ng-select>
                </ng-template>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button class="btn btn-light" (click)="close()">Close</button>
    <jft-submit-button
        (onClick)="create()"
        [class]="'btn btn-outline-primary'"
        [title]="'Save'"
        [disabled]="form.invalid"
        [loading]="form.disabled"
        [loadingTitle]="'Saving'" triggers="mouseenter:mouseleave" placement="right">
    </jft-submit-button>
</div>
